import { PlateTypeEnum } from './cutting-panel-outline.model';

export class CuttingCustomHole {
  name: string;
  schemaId: number;
  x = 0;
  y = 0;
  z = 0;
  diameter = 0;
  depth = 0;
  basePoint: FastenerBasePointEnum = FastenerBasePointEnum.Start;
  type: PlateTypeEnum = PlateTypeEnum.Face;
}

export enum FastenerBasePointEnum {
  Start,
  End,
}
